"use client";

import "./globals.scss";
import "antd/dist/reset.css";
import { Inter_Tight } from "next/font/google";
import { ThemeProvider } from "@/contexts/themeContext/themeContext";
import { AntdRegistry } from "@ant-design/nextjs-registry";
import ThemedApp from "@/components/theme/theme_app";

const inter = Inter_Tight({
  subsets: ["latin"],
  variable: "--font-inter-tight",
});

// Custom hook for detecting mobile view

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html lang="en">
      <body
        className={inter.className + " bg-background "}
      >
        <AntdRegistry>
          <ThemeProvider>
            <ThemedApp>{children}</ThemedApp>
          </ThemeProvider>
        </AntdRegistry>
      </body>
    </html>
  );
}
